import { InjectionToken } from '@angular/core';
import { DocumentReference } from '@principle-theorem/shared';
import { Observable, of } from 'rxjs';

export const MULTIFACTOR_CURRENT_USER_DOC = new InjectionToken<
  Observable<{ phone: string; ref: DocumentReference } | undefined>
>('MULTIFACTOR_CURRENT_USER_DOC', {
  factory: () => of(undefined),
});
